import { IconButton } from '@mui/material';
import clsx from 'clsx';
import React, { memo } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { ID8_GEN_TYPES, REACTIONS } from '../../../constants';
import { ICONS } from '../../../icons';
import Icon from '../../../icons/Icon';
import CommonTooltip from '../../../components/common-tooltip/CommonTooltip';
import useImagesGenerationStatus from '../../hooks/useImagesGenerationStatus';

import scss from './MessageCard.module.scss';

const CommonActions = ({ onSelect, onInfo, onEditStart, onLike, onDelete, isButtonsDisabled, messageProps }) => {
  const { t } = useTranslation('id8');

  const { id, message, selected, reaction, createType } = messageProps;

  const { id: projectId } = useParams();
  const generatingMessageId = useSelector((state) => state.id8.generatingMessageId);
  const isImagesGenerating = useImagesGenerationStatus({ genType: ID8_GEN_TYPES.IMAGES });

  const handleSelect = () => {
    if (isImagesGenerating) return;

    onSelect({ id, selected, projectId });
  };

  const handleShowInfo = () => {
    onInfo(messageProps);
  };

  const handleEditStart = () => {
    onEditStart({ id, message });
  };

  const handleLike = () => {
    onLike({ id, reaction: reaction === REACTIONS.LIKE ? '' : REACTIONS.LIKE, createType });
  };

  const handleDelete = () => {
    onDelete(messageProps);
  };

  return (
    <div className={scss.actionsCell}>
      <IconButton
        onClick={handleSelect}
        color='inherit'
        classes={{ root: scss.iconButton }}
        disabled={isButtonsDisabled || isImagesGenerating}>
        {generatingMessageId === id ? (
          <RotatingLines strokeColor='#fdbf47' strokeWidth='5' animationDuration='0.75' width={18} visible={true} />
        ) : (
          <Icon
            icon={ICONS.PointerToTheRight}
            disableCommonColors
            className={clsx(scss.strokeIcon, scss.pointerIcon, selected && scss.strokeIconSelected)}
          />
        )}
      </IconButton>

      <IconButton
        onClick={handleShowInfo}
        color='inherit'
        classes={{ root: scss.iconButton }}
        disabled={isButtonsDisabled}>
        <Icon icon={ICONS.Info} disableCommonColors className={scss.strokeIcon} />
      </IconButton>

      <IconButton
        onClick={handleEditStart}
        color='inherit'
        classes={{ root: scss.iconButton }}
        disabled={isButtonsDisabled}>
        <Icon icon={ICONS.Edit} disableCommonColors className={scss.fillIcon} />
      </IconButton>

      <IconButton onClick={handleLike} color='inherit' classes={{ root: scss.iconButton }} disabled={isButtonsDisabled}>
        <Icon
          icon={ICONS.Like}
          disableCommonColors
          className={clsx(scss.strokeIcon, reaction === REACTIONS.LIKE && scss.strokeIconSelected)}
        />
      </IconButton>

      <IconButton
        onClick={handleDelete}
        color='inherit'
        classes={{ root: scss.iconButton }}
        disabled={isButtonsDisabled}>
        <Icon icon={ICONS.Delete} disableCommonColors className={scss.fillIcon} />
      </IconButton>
    </div>
  );
};

export default memo(CommonActions);
